// extracted by mini-css-extract-plugin
export default {"select":"bOw7m","select--short":"qDkVE","select__title":"lvg6C"};